// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"bf44f101","453":"3941ab70","455":"602fb2c2","977":"80ed3e08"}[chunkId] + ".chunk.js";
};